import React, { ChangeEvent, Component } from "react";
import { observer } from "mobx-react";

import { IAnnotationField } from "@formant/core/model/IAnnotationField";
import { IAnnotationFieldValue } from "@formant/core/model/IAnnotationFieldValue";
import { ITags } from "@formant/core/model/ITags";
import { Uuid } from "@formant/core/model/Uuid";
import { InputElement } from "@formant/ui/component/common/Field";

import { annotationTemplateStore } from "../../stores";
import { SelectField } from "../common/SelectField";

export interface IEditSheetChoiceAnnotationFieldProps {
    annotationTemplateId: Uuid;
    field: IAnnotationField<"sheet">;
    tags: ITags;
    onChange: (tags: ITags) => void;
    className?: string;
    invalid: boolean;
}

@observer
export class EditSheetChoiceAnnotationField extends Component<IEditSheetChoiceAnnotationFieldProps> {
    private fieldValues: IAnnotationFieldValue[] = [];

    public render() {
        const { onChange } = this;
        const { annotationTemplateId, field, tags, className, invalid } =
            this.props;
        const { key } = field;

        const tagValue = tags[key];
        const fieldValue = tagValue;
        const value: IAnnotationFieldValue | undefined =
            (tagValue &&
                fieldValue && {
                    key: tagValue,
                    value: fieldValue,
                    tags: {},
                }) ||
            undefined;
        this.fieldValues =
            annotationTemplateStore.fieldValuesQuery({
                annotationTemplateId,
                key,
                tags,
            }) || this.fieldValues;
        const fieldValues = this.fieldValues;

        return (
            <div className={className}>
                <SelectField
                    label={field.name}
                    value={value?.key || ""}
                    onChange={onChange}
                    invalid={invalid}
                    small={true}
                >
                    <option key="" value="" />
                    {fieldValues.map(_ => (
                        <option key={_.key} value={_.key}>
                            {_.value}
                        </option>
                    ))}
                </SelectField>
            </div>
        );
    }

    public onChange = (event: ChangeEvent<InputElement>): void => {
        const value = event.target.value;
        const { field, tags, onChange } = this.props;
        const { key } = field;
        if (value) {
            onChange({ ...tags, [key]: value });
        } else {
            const { [key]: _, ...rest } = tags;
            onChange(rest);
        }
    };
}
